import { useEffect, useRef, type InputHTMLAttributes } from 'react';

import styles from './Checkbox.module.css';

export type CheckboxSize = 'large' | 'default' | 'small';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'checked' | 'onChange' | 'size' | 'type'> {
  /** Figma Border=on：带边框的卡片式多选项。 */
  border?: boolean;
  /** 仅用于无障碍命名，不渲染可见文字；与 `label` 二选一。 */
  ariaLabel?: string;
  checked: boolean;
  indeterminate?: boolean;
  label?: string;
  onCheckedChange: (checked: boolean) => void;
  size?: CheckboxSize;
}

export function Checkbox({ ariaLabel, border = false, checked, className, disabled, indeterminate = false, label, onCheckedChange, size = 'default', ...inputProps }: CheckboxProps) {
  const controlRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (controlRef.current) {
      controlRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <label
      className={[styles.root, className].filter(Boolean).join(' ')}
      data-border={border || undefined}
      data-checked={checked || indeterminate || undefined}
      data-disabled={disabled || undefined}
      data-size={size}
    >
      <input
        {...inputProps}
        aria-checked={indeterminate ? 'mixed' : undefined}
        aria-label={ariaLabel}
        checked={checked}
        className={styles.control}
        disabled={disabled}
        onChange={(event) => onCheckedChange(event.target.checked)}
        ref={controlRef}
        type="checkbox"
      />
      <span aria-hidden="true" className={styles.indicator} />
      {label ? <span className={styles.label}>{label}</span> : null}
    </label>
  );
}
